module.exports = __webpack_public_path__ + "fonts/NotoSans-Light.39bc3dc0.eot";